module.exports = __webpack_public_path__ + "static/roofs-comingsoon2-06e7a8924b3452e58d8413a5ee74f3cc.jpg";